module.exports = __webpack_public_path__ + "static/media/ope_anu_961x640.1751d844.jpg";